import { Injectable } from '@angular/core';
import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';
import startCase from 'lodash-es/startCase';

@Injectable({ providedIn: 'root' })
@Pipe({ name: 'displaycase' })
export class DisplayCasePipe implements PipeTransform {

  transform(
    value: any
  ): any {

    return startCase(
      value
        .replace('_', ' ')
        .toLocaleLowerCase()
    );
  }

}
